module.exports = __webpack_public_path__ + "static/media/logo_org_md.de04f522.svg";